import { RdoRhythmPoint } from "./RdoRhythmChart";
import { RdoRitmoDiarioResponse } from "./rdoRitmoDiario.types";

const WEEKDAYS = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];

function labelFromIso(iso: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if (!m) return iso;
  const y = Number(m[1]);
  const mo = Number(m[2]) - 1;
  const d = Number(m[3]);
  const dt = new Date(y, mo, d);
  const dow = WEEKDAYS[dt.getDay()] || "";
  return `${dow}\n${m[3]}/${m[2]}`;
}

export function mapRdoRitmoDiarioToChart(
  data?: RdoRitmoDiarioResponse | null
): { metaDiaria: number | null; points: RdoRhythmPoint[] } {
  if (!data?.dias?.length) {
    return { metaDiaria: data?.metaDiaria ?? null, points: [] };
  }
  return {
    metaDiaria:
      data.metaDiaria != null && !Number.isNaN(Number(data.metaDiaria))
        ? Number(data.metaDiaria)
        : null,
    points: data.dias.map((d) => ({
      name: labelFromIso(d.data),
      value: Number(d.ritmoDiario) || 0,
    })),
  };
}
